/*
  Create Your Piece — step 04 · Personalize (10.05 / 10.05b / 10.06).
  4a: the three ways to finish the piece, priced from the product's real
      Personalization variants (the difference to "No Engraving").
  4b: the engraving field — type rail, live counter, inline validation.
      Text is never truncated; SEE MY PIECE stays visible but inactive with
      a reason until the text fits.
  Text and crest are exclusive: switching asks before anything is cleared.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  var WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
  var COPY = {
    A: {
      none: ['Keep it clean', 'No engraving. The piece as designed, front and back.', 'No engraving, front or back.'],
      text: ['Add text', 'A name, a number, initials — or your own line. Five fonts, live preview.', 'Name, number or initials. Five fonts.'],
      crest: ['Add your crest', 'Your club mark or team logo, prepared for engraving and confirmed before production.', 'Club mark or team logo, confirmed before production.']
    },
    B: {
      none: ['Keep it clean', 'No engraving. The chain and the tag exactly as designed.', 'No engraving. The chain and the tag exactly as designed.'],
      text: ['Add initials or number', 'Up to two characters on the tag beside the clasp. Five fonts, live preview.', 'Up to two characters on the tag beside the clasp.'],
      crest: ['Add your crest', 'Your club mark or team logo on the same tag, prepared for engraving and confirmed before production.', 'Club mark or team logo on the same tag, confirmed before production.']
    }
  };

  CYP.use(function (cyp) {
    var root = cyp.root;
    var pa = root.querySelector('[data-pb-step="4"]');
    var pt = root.querySelector('[data-pb-step="4b"][data-pb-kind="text"]');
    var S = cyp.settings;

    var input = pt.querySelector('[data-text-input]');
    var field = pt.querySelector('[data-text-field]');
    var count = pt.querySelector('[data-text-count]');
    var help = pt.querySelector('[data-text-help]');
    var error = pt.querySelector('[data-text-error]');
    var textNext = pt.querySelector('[data-text-next]');
    var reason = pt.querySelector('[data-text-reason]');

    function delta(c) { return c ? '+' + cyp.money(c) : 'Included'; }
    function cap(t) { return t.charAt(0).toUpperCase() + t.slice(1); }

    /* ---------------------------------------------------------- 4a */
    function renderTypes() {
      var s = cyp.state;
      var pc = cyp.pieceBy();
      if (!pc) return;
      var m = cyp.model(pc.family);
      var prices = cyp.optionPrices();
      var lim = cyp.limit(pc.family);
      var copy = COPY[m];
      pa.querySelectorAll('[data-type]').forEach(function (card) {
        var t = card.getAttribute('data-type');
        var c = copy[t];
        card.querySelector('[data-type-name]').textContent = c[0];
        var d = c[1], dm = c[2];
        if (m === 'B' && t === 'text') {
          d = d.replace('two characters', WORDS[lim] + (lim === 1 ? ' character' : ' characters'));
          dm = dm.replace('two characters', WORDS[lim] + (lim === 1 ? ' character' : ' characters'));
        }
        card.querySelector('[data-type-desc]').textContent = d;
        card.querySelector('[data-type-desc-m]').textContent = dm;
        var price = '';
        if (t === 'none') price = 'Included';
        else if (!prices) price = t === 'text' ? (S.fallback_text || '') : (S.fallback_crest || '');
        else if (t === 'crest') price = delta(prices.crest);
        else if (lim <= 3 || prices.t13 === prices.t410) price = delta(prices.t13);
        else price = 'From ' + delta(prices.t13);
        var el = card.querySelector('[data-type-price]');
        el.textContent = price;
        el.classList.toggle('is-included', price === 'Included' || (price === S.fallback_text && !!price && !/\d/.test(price)));
        var inp = card.querySelector('input');
        inp.checked = t === s.type;
        card.classList.toggle('is-selected', inp.checked);
      });
      var textIncluded = prices ? prices.t13 === 0 : !/\d/.test(S.fallback_text || '');
      pa.querySelector('[data-type-sub]').textContent = m === 'B'
        ? (textIncluded
            ? 'The Curb Chain carries a tag, not a pendant — so initials and numbers are included rather than an upgrade.'
            : 'The Curb Chain carries a tag, not a pendant.')
        : 'Three ways to finish the piece. The front keeps the sport either way.';
      pa.querySelector('[data-type-helper]').textContent = m === 'B'
        ? cap(WORDS[lim]) + (lim === 1 ? ' character is' : ' characters is') + ' the hard limit on this tag.'
        : 'Crest and text are mutually exclusive — choosing one clears the other, and the builder says so before it does.';
      pa.querySelector('[data-type-next]').setAttribute('aria-disabled', s.type ? 'false' : 'true');
    }

    function chooseType(t) {
      var s = cyp.state;
      if (t === s.type) return;
      var go = function () {
        var patch = { type: t };
        if (t === 'crest') patch.value = '';
        cyp.set(patch);
        cyp.track('personalization_type_selected', { personalization_type: t });
      };
      if (t === 'crest' && s.type === 'text' && s.value) {
        cyp.confirm('Choosing a crest clears your text “' + s.value + '”.', 'Clear my text', 'Keep my text')
          .then(function (ok) { if (ok) go(); else renderTypes(); });
        return;
      }
      if (t === 'text' && s.type === 'crest' && s.crest) {
        cyp.confirm('Choosing text clears your crest choice.', 'Choose text', 'Keep my crest')
          .then(function (ok) { if (ok) go(); else renderTypes(); });
        return;
      }
      go();
    }

    pa.addEventListener('change', function (e) {
      if (e.target.name === 'pb-type') chooseType(e.target.value);
    });
    function commitType() {
      var t = cyp.state.type;
      if (!t) return;
      if (t === 'none') {
        cyp.track('personalization_completed', { personalization_type: 'none', value_length: 0, font: null });
        cyp.go('5');
      } else cyp.go('4b');
    }
    pa.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.name === 'pb-type') { e.preventDefault(); commitType(); }
    });
    pa.querySelector('[data-type-next]').addEventListener('click', commitType);

    /* ---------------------------------------------------------- 4b text */
    function renderText() {
      var s = cyp.state;
      var pc = cyp.pieceBy();
      if (!pc) return;
      var lim = cyp.limit(pc.family);
      var kinds = cyp.kindsFor(pc.family);
      pt.querySelectorAll('[data-kind]').forEach(function (k) {
        var v = k.getAttribute('data-kind');
        k.hidden = kinds.indexOf(v) < 0;
        var inp = k.querySelector('input');
        inp.checked = v === s.kind;
        k.classList.toggle('is-selected', inp.checked);
      });
      if (input.value !== s.value) input.value = s.value;
      input.className = input.className.replace(/\bpb-ff--\w+/g, '').trim() + ' pb-ff--' + s.font;
      input.setAttribute('inputmode', s.kind === 'number' ? 'numeric' : 'text');
      var len = (s.value || '').length;
      count.textContent = len + ' / ' + lim;
      field.dataset.len = len <= 4 ? 's' : len <= 7 ? 'm' : 'l';
      var noun = pc.family === 'necklace' ? 'pendant' : pc.family === 'curb' ? 'tag' : 'bracelet';
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      var prices0 = cyp.optionPrices();
      var tierLine = prices0 && lim > 3 && prices0.t13 !== prices0.t410
        ? '1–3 characters ' + delta(prices0.t13) + ' · 4–' + lim + ' characters ' + delta(prices0.t410)
        : '';
      var upTo = 'Up to ' + WORDS[lim] + (lim === 1 ? ' character' : ' characters');
      help.textContent = desktop ? upTo + (tierLine ? ' · ' + tierLine : '') : (tierLine || upTo);
      var tsub = pt.querySelector('[data-text-sub]');
      if (tsub) tsub.textContent = pc.family === 'curb'
        ? 'Engraving sits on the tag beside the clasp. The chain itself is never engraved.'
        : 'Engraving sits on the ' + (noun === 'pendant' ? 'back' : noun === 'bracelet' ? 'plate' : 'back') + '. The front keeps the sport either way.';
      var problem = cyp.textProblem();
      var msg = '';
      if (problem === 'long') msg = pc.family === 'curb' ? 'The curb chain tag takes ' + WORDS[lim] + ' characters. Try initials.' : 'This piece takes up to ' + WORDS[lim] + ' characters.';
      if (problem === 'chars') msg = 'Letters, numbers and spaces only.';
      error.textContent = msg;
      field.classList.toggle('is-error', !!msg);
      count.classList.toggle('is-error', problem === 'long');
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      textNext.setAttribute('aria-disabled', problem ? 'true' : 'false');
      reason.textContent = problem === 'empty' ? 'Type your engraving to continue.' : msg;
    }

    input.addEventListener('input', function () { cyp.set({ value: input.value }); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); textNext.click(); }
    });
    pt.addEventListener('change', function (e) {
      if (e.target.name === 'pb-kind') cyp.set({ kind: e.target.value });
    });
    textNext.addEventListener('click', function () {
      if (cyp.textProblem()) { input.focus(); return; }
      var s = cyp.state;
      cyp.track('personalization_completed', { personalization_type: 'text', value_length: s.value.length, font: cyp.FONTS[s.font] });
      cyp.go('5');
    });

    cyp.on('state', function () { renderTypes(); renderText(); });
    window.addEventListener('resize', renderText);
  });
})();
